import {
    Component,
    OnInit,
    Input,
    ViewEncapsulation,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import { WtfAnimations } from "../../../../utils/others/core/animations";
import { RecordAction } from "../../../../utils/enums/shared/enums";

type SIZE = "sm" | "md" | "lg" | "auto";

@Component({
    selector: "wtf-dialogcontent",
    templateUrl: "./dialog-content.component.html",
    styleUrls: ["./dialog-content.component.scss"],
    animations: WtfAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class DialogContentComponent implements OnInit, OnChanges {
    @Output() closeModal = new EventEmitter();
    @Input() dialogTitle: string;
    @Input() action: RecordAction;
    @Input() size: SIZE;

    modalClass: string;

    recordAction = RecordAction;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["size"]) {
            this.modalClass = `dialog-content-wrapper ${this.size}`;
        }
    }

    ngOnInit() {
        this.modalClass = `dialog-content-wrapper ${this.size}`;
    }

    close() {
        this.closeModal.emit();
    }
}
